export function validatePassword(password) {
    return {
        minLength: password.length >= 8,
        hasNumber: /\d/.test(password),
        hasSpecialChar: /[^A-Za-z0-9]/.test(password),
        hasUpperCase: /[A-Z]/.test(password),
        hasLowerCase: /[a-z]/.test(password),
    };
}

export function isPasswordValid(password) {
    return Object.values(validatePassword(password)).every(Boolean);
}